export const environment = {
    production: false,
    //apiUrl: 'https://betaapi.noboa.org/api',
    apiUrl: 'https://betaapi.noboa.org/api',
    blobUrl: 'https://bandastoragedev.blob.core.windows.net/picturechoice/',
    fileAnswerUrl: 'https://bandastoragedev.blob.core.windows.net/fileanswer/',
    appUrl: 'http://localhost:4200/'
    //appUrl: 'http://banda-app-dev.azurewebsites.net/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts